<template>
  <nav class="navbar  navbar-expand-lg navbar-dark fixed-top">
    <div class="container-fluid">
      <router-link to="/" class="navbar-brand py-px-0 pe-5" href="index.html">
          <img src="../assets/Soncraft_logo.png" alt="logo here" width="35px" height="35px">
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <img src="../assets/menu_icon.png" alt="" width="30px" height="30px">
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <router-link @click="scrollToTop" :to="{ name: 'Home' }"> 
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link @click="scrollToTop" :to="{ name: 'Projects' }"> 
              Projects
            </router-link>
          </li>
          <li class="nav-item">
            <router-link @click="scrollToTop" :to="{ name: 'Games' }"> 
              Games
            </router-link>
          </li>
          <li class="nav-item">
            <router-link @click="scrollToTop" :to="{ name: 'About' }"> 
              About
            </router-link>
          </li>
        </ul>
        <form target="_blank" action="https://www.paypal.com/donate" method="post">
            <input type="hidden" name="hosted_button_id" value="4ZSHDKQ3H8LQJ" />
            <input type="submit" name="submit" class="donate-btn" value="Donate &#10084;" title="Help Improve the Site"/>
        </form>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
 methods: { 
   scrollToTop() {
      window.scrollTo(0,0);
   }
  }
}
</script>

<style>
.navbar{
  background: #212121;
  padding-left: 10%;
  padding-right: 10%;
  z-index: 100;
}
.navbar-brand img{
  width: 35px;
  height: 35px;
}
.navbar-toggler img{
  width: 30px;
  height: 30px;
}
#navbarSupportedContent ul li a{
  text-decoration: none;
  text-transform: uppercase;
  color: #808080;
  font-size: 1.2rem;
  padding: 0 2rem;
}
#navbarSupportedContent ul li a:hover{
  color: #ff6600;
}
.donate-btn{
  color: #ff6600;
  background-color: #ffffff00;
  border: 2px solid #ff6600;
  border-radius: 10px;
  padding: 5px 10px;
}
.donate-btn:hover{
  color: #fff;
  background-color: #ff6600;
  border: 2px solid #212121;
}
@media screen and (max-width: 900px) {
  .navbar{
    padding-left: 3%;
    padding-right: 3%;
  }
  #navbarSupportedContent ul{
    padding-left: 0.3rem;
    margin-left: 1rem;
    margin: .7rem 0;
  }
  #navbarSupportedContent ul li a{
    padding: 1rem 0;
  }
  #navbarSupportedContent ul li{
    margin: .7rem 0;
  }
}
</style>